import { render, staticRenderFns } from "./CreateContentTemplate.vue?vue&type=template&id=68686900"
import script from "./CreateContentTemplate.vue?vue&type=script&lang=js"
export * from "./CreateContentTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateContentTemplate.vue?vue&type=style&index=0&id=68686900&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports